// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608100715/js/" + chunkId + "." + {"44":"66dc995b","225":"a848473d","481":"c1c6d87a","486":"13cf7744","770":"ce2b2d17"}[chunkId] + ".0.6007474973747504.chunk.js";
};